// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/***********************
* GLOBAL COLOR TOKENS * 
***********************/
.CodeEditorMenu-module__disabled--pPsBv {
  opacity: 0.5;
  cursor: not-allowed !important;
}

.CodeEditorMenu-module__menu--kW_kc {
  display: flex;
  padding: 0.75rem 0rem;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  position: fixed;
  right: 1rem;
  top: 3rem;
  z-index: 3;
  border-radius: 0.5;
  border: 1px solid var(--context-menu-border-color);
  background: var(--context-menu-background-color);
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(40px);
  user-select: none;
}

.CodeEditorMenu-module__divider--ZCTj9 {
  height: 1px;
  width: 100%;
  background: var(--context-menu-border-color);
}

.CodeEditorMenu-module__optionContainer--SMhYC {
  display: flex;
  flex-direction: column;
}

.CodeEditorMenu-module__containerHeader--l1F3l {
  display: flex;
  padding: 0.375rem 1rem 0.375rem 0.75rem;
  justify-content: left;
  align-items: center;
  gap: 0.625rem;
  align-self: stretch;
  flex: 1 0 0;
  color: var(--context-menu-header-color);
  font-family: "Roboto Flex";
  font-size: 0.813rem;
  letter-spacing: 0.008rem;
}

.CodeEditorMenu-module__option--BsTHJ {
  display: flex;
  flex-shrink: 0;
  height: 2.25rem;
  padding: 0rem 0.75rem;
  align-items: center;
  gap: 0.5rem;
  align-self: stretch;
  font-size: 1rem;
  background-color: #ffffff;
}
.CodeEditorMenu-module__option--BsTHJ:disabled .CodeEditorMenu-module__text--Y_oci {
  color: revert;
}
.CodeEditorMenu-module__option--BsTHJ:hover:not(:disabled) {
  background: var(--context-menu-hover-color);
  cursor: pointer;
}

.CodeEditorMenu-module__icon--J6xl8 {
  height: 1rem;
  width: 1rem;
}

.CodeEditorMenu-module__plusIcon--a_cuq {
  height: 0.625rem;
  width: 0.625rem;
}

.CodeEditorMenu-module__fileCount--xPN2n {
  display: flex;
  width: 2rem;
  height: 1.5rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.625rem;
  flex-shrink: 0;
  border-radius: 100px;
  border: 1px solid var(--context-menu-file-count-border-color);
  color: var(--context-menu-text-color);
  text-align: center;
  font-family: "Roboto Flex";
}
.CodeEditorMenu-module__fileCount--xPN2n.CodeEditorMenu-module__empty--ByPwd {
  border-color: transparent;
}

.CodeEditorMenu-module__text--Y_oci {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  flex: 1 0 0;
  overflow: hidden;
  color: var(--context-menu-text-color);
  text-overflow: ellipsis;
  text-align: left;
  font-family: "Roboto Flex";
  width: 10rem;
}

.CodeEditorMenu-module__smallerTextArea--Sp3b7 {
  width: 6.1rem;
}

.CodeEditorMenu-module__hotkey--BTt0c {
  display: flex;
  height: 2rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  font-family: "Roboto Flex";
  color: var(--context-menu-hotkey-color);
}

.CodeEditorMenu-module__openTabsIcon--Z5JS_ {
  display: flex;
  height: 2rem;
  width: 4rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
  font-family: "Roboto Flex";
}

.CodeEditorMenu-module__tabSubMenu--fblWu {
  position: fixed;
  z-index: 4;
  max-height: 25rem;
}

.CodeEditorMenu-module__submenuContent--iuGyR {
  overflow: scroll;
}`, "",{"version":3,"sources":["webpack://./src/_variables.scss","webpack://./src/components/CodeEditorMenu/CodeEditorMenu.module.scss"],"names":[],"mappings":"AAAA;;uBAAA;ACEA;EACC,YAAA;EACA,8BAAA;AAED;;AACA;EAEC,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EAGA,kBAAA;EACA,kDAAA;EACA,gDAAA;EACA,gDAAA;EACA,2BAAA;EAGA,iBAAA;AAHD;;AAKA;EACC,WAAA;EACA,WAAA;EACA,4CAAA;AAFD;;AAIA;EACC,aAAA;EACA,sBAAA;AADD;;AAIA;EACC,aAAA;EACA,uCAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EAEA,uCAAA;EACA,0BAAA;EACA,mBAAA;EACA,wBAAA;AAFD;;AAKA;EACC,aAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EAGA,eAAA;EACA,yBAAA;AAJD;AAMC;EACC,aAAA;AAJF;AAOC;EACC,2CAAA;EACA,eAAA;AALF;;AASA;EACC,YAAA;EACA,WAAA;AAND;;AASA;EACC,gBAAA;EACA,eAAA;AAND;;AASA;EACC,aAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,oBAAA;EACA,6DAAA;EAEA,qCAAA;EACA,kBAAA;EACA,0BAAA;AAPD;AASC;EACC,yBAAA;AAPF;;AAWA;EAEC,oBAAA;EACA,4BAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;EAGA,gBAAA;EACA,qCAAA;EACA,uBAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;AAXD;;AAcA;EACC,aAAA;AAXD;;AAcA;EACC,aAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;EACA,uCAAA;AAXD;;AAcA;EACC,aAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,0BAAA;AAXD;;AAcA;EACC,eAAA;EACA,UAAA;EACA,iBAAA;AAXD;;AAcA;EACC,gBAAA;AAXD","sourcesContent":["/***********************\n* GLOBAL COLOR TOKENS * \n***********************/\n$--neutral-00: #ffffff;\n$--neutral-50: #fafafa;\n$--neutral-100: #f4f4f5;\n$--neutral-200: #e4e4e7;\n$--neutral-300: #d4d4d8;\n$--neutral-400: #a1a1aa;\n$--neutral-500: #71717a;\n$--neutral-600: #52525b;\n$--neutral-700: #3f3f46;\n$--neutral-800: #27272a;\n$--neutral-900: #18181b;\n\n$--neutral-variant-00: #f8fafc;\n$--neutral-variant-50: #f1f5f9;\n$--neutral-variant-100: #e2e8f0;\n$--neutral-variant-200: #cbd5e1;\n$--neutral-variant-300: #b9c3d1;\n$--neutral-variant-400: #94a2b8;\n$--neutral-variant-500: #64738b;\n$--neutral-variant-600: #475569;\n$--neutral-variant-700: #334155;\n$--neutral-variant-800: #1e293b;\n$--neutral-variant-900: #0f172a;\n\n$--primary-00: #f7fbff;\n$--primary-50: #eff6ff;\n$--primary-100: #dbe9fe;\n$--primary-200: #bfdbfe;\n$--primary-300: #92c5fd;\n$--primary-400: #60a5fa;\n$--primary-500: #3c82f6;\n$--primary-600: #2463eb;\n$--primary-700: #1c4ed8;\n$--primary-800: #1d40ae;\n$--primary-900: #1f3a8a;\n\n$--secondary-00: #fcfffd;\n$--secondary-50: #ecfef6;\n$--secondary-100: #d1fae5;\n$--secondary-200: #a8f3d0;\n$--secondary-300: #6ee7b7;\n$--secondary-400: #34d399;\n$--secondary-500: #12b981;\n$--secondary-600: #079669;\n$--secondary-700: #047857;\n$--secondary-800: #076046;\n$--secondary-900: #064e3b;\n\n$--error-00: #fffdfd;\n$--error-50: #fef2f2;\n$--error-100: #fee2e1;\n$--error-200: #fecaca;\n$--error-300: #fda5a5;\n$--error-400: #f87171;\n$--error-500: #ef4444;\n$--error-600: #dc2625;\n$--error-700: #b91c1b;\n$--error-800: #991b1b;\n$--error-900: #7f1c1d;\n","@import \"../../variables.scss\";\n\n.disabled {\n\topacity: 0.5;\n\tcursor: not-allowed !important;\n}\n\n.menu {\n\t// Layout\n\tdisplay: flex;\n\tpadding: 0.75rem 0rem;\n\tflex-direction: column;\n\tjustify-content: flex-end;\n\talign-items: center;\n\tgap: 0.5rem;\n\tposition: fixed;\n\tright: 1rem;\n\ttop: 3rem;\n\tz-index: 3;\n\n\t// Style\n\tborder-radius: 0.5;\n\tborder: 1px solid var(--context-menu-border-color);\n\tbackground: var(--context-menu-background-color);\n\tbox-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.3);\n\tbackdrop-filter: blur(40px);\n\n\t// Prevent text selection in context menu\n\tuser-select: none;\n}\n.divider {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--context-menu-border-color);\n}\n.optionContainer {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.containerHeader {\n\tdisplay: flex;\n\tpadding: 0.375rem 1rem 0.375rem 0.75rem;\n\tjustify-content: left;\n\talign-items: center;\n\tgap: 0.625rem;\n\talign-self: stretch;\n\tflex: 1 0 0;\n\n\tcolor: var(--context-menu-header-color);\n\tfont-family: \"Roboto Flex\";\n\tfont-size: 0.813rem;\n\tletter-spacing: 0.008rem;\n}\n\n.option {\n\tdisplay: flex;\n\tflex-shrink: 0;\n\theight: 2.25rem;\n\tpadding: 0rem 0.75rem;\n\talign-items: center;\n\tgap: 0.5rem;\n\talign-self: stretch;\n\n\t// button reset css\n\tfont-size: 1rem;\n\tbackground-color: #{$--neutral-00};\n\n\t&:disabled .text {\n\t\tcolor: revert;\n\t}\n\n\t&:hover:not(:disabled) {\n\t\tbackground: var(--context-menu-hover-color);\n\t\tcursor: pointer;\n\t}\n}\n\n.icon {\n\theight: 1rem;\n\twidth: 1rem;\n}\n\n.plusIcon {\n\theight: 0.625rem;\n\twidth: 0.625rem;\n}\n\n.fileCount {\n\tdisplay: flex;\n\twidth: 2rem;\n\theight: 1.5rem;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 0.625rem;\n\tflex-shrink: 0;\n\tborder-radius: 100px;\n\tborder: 1px solid var(--context-menu-file-count-border-color);\n\n\tcolor: var(--context-menu-text-color);\n\ttext-align: center;\n\tfont-family: \"Roboto Flex\";\n\n\t&.empty {\n\t\tborder-color: transparent;\n\t}\n}\n\n.text {\n\t// Display\n\tdisplay: -webkit-box;\n\t-webkit-box-orient: vertical;\n\tline-clamp: 1;\n\t-webkit-line-clamp: 1;\n\tflex: 1 0 0;\n\n\t// Typography\n\toverflow: hidden;\n\tcolor: var(--context-menu-text-color);\n\ttext-overflow: ellipsis;\n\ttext-align: left;\n\tfont-family: \"Roboto Flex\";\n\twidth: 10rem;\n}\n\n.smallerTextArea {\n\twidth: 6.1rem;\n}\n\n.hotkey {\n\tdisplay: flex;\n\theight: 2rem;\n\tpadding: 0.5rem;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 0.25rem;\n\tfont-family: \"Roboto Flex\";\n\tcolor: var(--context-menu-hotkey-color);\n}\n\n.openTabsIcon {\n\tdisplay: flex;\n\theight: 2rem;\n\twidth: 4rem;\n\tpadding: 0.5rem;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 0.25rem;\n\tfont-family: \"Roboto Flex\";\n}\n\n.tabSubMenu {\n\tposition: fixed;\n\tz-index: 4;\n\tmax-height: 25rem;\n}\n\n.submenuContent {\n\toverflow: scroll;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disabled": `CodeEditorMenu-module__disabled--pPsBv`,
	"menu": `CodeEditorMenu-module__menu--kW_kc`,
	"divider": `CodeEditorMenu-module__divider--ZCTj9`,
	"optionContainer": `CodeEditorMenu-module__optionContainer--SMhYC`,
	"containerHeader": `CodeEditorMenu-module__containerHeader--l1F3l`,
	"option": `CodeEditorMenu-module__option--BsTHJ`,
	"text": `CodeEditorMenu-module__text--Y_oci`,
	"icon": `CodeEditorMenu-module__icon--J6xl8`,
	"plusIcon": `CodeEditorMenu-module__plusIcon--a_cuq`,
	"fileCount": `CodeEditorMenu-module__fileCount--xPN2n`,
	"empty": `CodeEditorMenu-module__empty--ByPwd`,
	"smallerTextArea": `CodeEditorMenu-module__smallerTextArea--Sp3b7`,
	"hotkey": `CodeEditorMenu-module__hotkey--BTt0c`,
	"openTabsIcon": `CodeEditorMenu-module__openTabsIcon--Z5JS_`,
	"tabSubMenu": `CodeEditorMenu-module__tabSubMenu--fblWu`,
	"submenuContent": `CodeEditorMenu-module__submenuContent--iuGyR`
};
export default ___CSS_LOADER_EXPORT___;
